import DistributorDetail from "./Detail";
import DistributorList from "./List";

export { DistributorList, DistributorDetail };
